import React, { Component } from 'react';
import { Translate } from "react-localize-redux";
import { connect } from 'react-redux';
import { ChangeNavbar } from '../../actions';
//import { Link } from "react-router-dom";

import Separator from '../../components/Separator';

import '../../components/Header.css';
import './Hatventure.css';

import logo from '../../images/games/hatventure/hatventure_logo.png';
import hatventure_icon from '../../images/games/hatventure/hatventure_icon.png';
import google_play_badge from '../../images/google-play-badge.png';

import {
  Container,
  Row,
  Col
} from 'reactstrap';


class Hatventure extends Component {
  constructor(props) {
    super(props);
    this.props.SetHeaderNavbar(true);
  }

  componentDidMount() {
    window.scrollTo(0, 0);
  }

  render() {
    return (
      <div className="content">
        <header className="masthead hatventure text-center text-white d-flex">
          <Container className="header-content">
            <Row className="header-image">
              <Col lg="8" className="mx-auto">
                <img className="img-fluid" src={logo} alt=""/>
              </Col>
            </Row>
            <br/><br/><br/>
            <Row className="header-text">
              <Col lg="10" className="mx-auto">
                <p className="text-faded mb-5"><Translate id="hatventure.header.subtitle">Disponible para descargar en Android:</Translate></p>
                <a className="google-link mx-auto" href="https://play.google.com/store/apps/details?id=com.GoneMadStudios.Hatventure" target="_blank" rel="noopener noreferrer">
                  <img src={google_play_badge} alt="Google Play Download Link" className="google-button"/>
                </a>
              </Col>
            </Row>
          </Container>
        </header>
        <Separator topSeparator="false" />

        <section>
          <Container className="hatventure">
            <Row>
              <Col lg="8" className="mx-auto text-center">
                <h2 className="title"><Translate id="hatventure.about.title">Hatventure - Juego de Puzles para Android</Translate></h2>
                <hr className="hr-line" />
              </Col>
            </Row>
            <Row className="abstract">
              <Col lg="8" className="mx-auto text-justify text">
                <br/>
                <p>
                  <Translate id="hatventure.about.text">
                      En Hatventure tomarás el control de Hatman, un pequeño coleccionista de sombreros que tendrá que explorar unas ruinas alienígenas,
                      resolviendo los puzles de cada nivel y avanzando por diferentes mundos.
                  </Translate>
                </p>
              </Col>
              <Col lg="4" className="mx-auto">
                <img src={hatventure_icon} alt="Hatventure Logo"/>
              </Col>
            </Row>
          </Container>
        </section>

        <section>
          <Container>
            <Row>
              <Col lg="8" className="mx-auto text-center">
                <hr className="hr-line" />
                <h2 className="title"><Translate id="hatventure.next">Próximante nuevas noticias</Translate></h2>
                <hr className="hr-line" />
              </Col>
            </Row>
          </Container>
        </section>
      </div>
      );
  }
}

function mapDispatchToProps(dispatch) {
  return {
    SetHeaderNavbar: (haveHeader) => {dispatch(ChangeNavbar(haveHeader))}
  }
}

function mapStateToProps(state) {
  return {  }
}

export default connect (
  mapStateToProps,
  mapDispatchToProps
)(Hatventure);
